import React, { useState } from 'react';
import { useObjectStore } from "../zustand/objects";
import { Button, Text, Group, Textarea, Modal, Stack, Box } from '@mantine/core';
import { nanoid } from 'nanoid'
import {
  editorModalShell,
  editorModalStrongTitleStyles,
  editorModalPrimaryButtonStyles,
  editorModalSecondaryButtonStyles,
  editorModalTextareaStyles,
  editorModalFootnoteBoxStyle,
} from "../styleFile";


export default function TextModal() {

  const { 
    addTextObject,
    currentObjectArtboard,
    textModalOpen,
    switchTextModalOpen,
    arrangeUndoRedo
  } = useObjectStore();

  const [textValue, setTextValue] = useState('')

  const onTextSubmit = () => { 
    if (textValue) {
      const id = nanoid()
       // send update to zustand first (so we have state to grab for undo array)
       addTextObject({ id: id, currentObjectArtboard, textKind: "plain text", content: textValue, matrix: null, undo: false })
       // send current state to undoActions
    arrangeUndoRedo({
      updateType: "objectAdd", 
      artboard: currentObjectArtboard, 
      objectID: id,
      undo:false
      })
      switchTextModalOpen()
    }
  }

  const onTextCancel = () => {
    switchTextModalOpen()
  }

  const handleChange = (e) => {
    setTextValue(e.target.value)
  }

  return (
    <Modal
      opened={textModalOpen}
      onClose={onTextCancel}
      title="Scene text"
      withCloseButton
      centered={editorModalShell.centered}
      radius={editorModalShell.radius}
      overlayProps={editorModalShell.overlayProps}
      styles={editorModalStrongTitleStyles}
      size={560}
    >
      <Stack gap="lg" p={20}>
        <Textarea
          onChange={handleChange}
          label={
            <Text component="span" size="sm" fw={600} c="var(--mbx-modal-primary-text, #111827)">
              Text
            </Text>
          }
          placeholder="Enter text…"
          minRows={5}
          radius="md"
          styles={editorModalTextareaStyles}
        />
        <Box
          p="md"
          style={{
            ...editorModalFootnoteBoxStyle,
            backgroundColor: "var(--mbx-modal-muted-fill, #f9fafb)",
          }}
        >
          <Text size="xs" c="dimmed" style={{ lineHeight: 1.55 }}>
            Text appears in the 3D scene. You can edit it after placing.
          </Text>
        </Box>
        <Group justify="flex-end" gap="sm" mt="xs">
          <Button radius={4} styles={editorModalSecondaryButtonStyles} onClick={() => onTextCancel()}>
            Cancel
          </Button>
          <Button radius={4} styles={editorModalPrimaryButtonStyles} onClick={() => onTextSubmit()}>
            Add to scene
          </Button>
        </Group>
      </Stack>
    </Modal>
  );
}
